module.exports = __webpack_public_path__ + "img/addTextNum5_1.c7c6533c.png";